module.exports = __webpack_public_path__ + "static/index/img/baikal-600.b0cef254.jpg";